module.exports = __webpack_public_path__ + "static/media/companyLogo.59c5f4f5.svg";